import { render } from "./MaterialsView.vue?vue&type=template&id=ee55b5c2"
import script from "./MaterialsView.vue?vue&type=script&lang=js"
export * from "./MaterialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__